var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FButton", {
    attrs: { prependIcon: "add" },
    on: {
      click: function ($event) {
        return _vm.$emit("tap")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }